/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.0.1
 */

import get from 'lodash/get';
import { SagaIterator } from 'redux-saga';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import { API_HOSTNAME, USER_SETTINGS } from '../../modules/app/Api';
import { LOAD_AUTH_DATA_SUCCESSFUL } from '../../pages/PageAuth/constants/authConstants';
import { ILoadAuthDataSuccessful } from '../../pages/PageAuth/types/authTypes';
import { settingsProfileSetParamComponentsAction } from '../../pages/PageSettings/components/SettingsProfile/settingsProfileActions';
import { ESettingsProfileComponents } from '../../pages/PageSettings/components/SettingsProfile/settingsProfileConstants';
import { requestSaga } from '../../sagas/requestSaga';
import { setHelpFlagFailAction, setHelpFlagSuccessAction } from './headerActions';
import { SET_HELP_FLAG } from './headerConstants';
import { TSetHelpFlagTipsAction } from './headerTypes';

export function* setHelpFlag(action: TSetHelpFlagTipsAction): SagaIterator {
    try {
        // send request
        yield call(requestSaga,
            API_HOSTNAME + USER_SETTINGS,
            'PUT',
            { helpFlag: action.payload });
        yield put(setHelpFlagSuccessAction(action.payload));
        yield put(settingsProfileSetParamComponentsAction({
            hintsIsEnabled: action.payload,
            component: ESettingsProfileComponents.HINTS,
        }));
    } catch (error: any) {
        yield put(setHelpFlagFailAction(error));
        console.log(error);
    }
}

export function* getHelpFlagFromAuthData(action: ILoadAuthDataSuccessful): SagaIterator {
    const helpFlag = get(action, 'payload.user.helpFlag', false);
    yield put(setHelpFlagSuccessAction(helpFlag));
}

export function* headerSaga() {
    yield all([
        takeEvery(LOAD_AUTH_DATA_SUCCESSFUL, getHelpFlagFromAuthData),
        takeEvery(SET_HELP_FLAG, setHelpFlag),
    ]);

}
